import React from 'react';
import { Layer, Line, Rect } from 'react-konva';

const VisibilityMaskLayer = ({ bounds, visibility, isGameMaster = false }) => {
  if (isGameMaster || visibility?.mode !== 'basic_los') return null;
  const polygons = Array.isArray(visibility?.polygons) ? visibility.polygons : [];
  return (
    <Layer listening={false}>
      <Rect x={bounds.x} y={bounds.y} width={bounds.width} height={bounds.height} fill="rgba(5, 8, 13, 0.96)" listening={false} />
      {polygons.map((polygon) => (
        <Line
          key={polygon.tokenId}
          points={(polygon.points || []).flatMap((point) => [point.x, point.y])}
          closed
          fill="#000"
          globalCompositeOperation="destination-out"
          listening={false}
        />
      ))}
    </Layer>
  );
};

export default VisibilityMaskLayer;
